import { z } from 'zod';
import {
  ALLOWED_MIME_TYPES,
  MAX_FILE_SIZE_BYTES,
  MAX_FILES_PER_SUBMISSION,
} from '../constants/file-upload.js';

export const fileRefSchema = z.object({
  s3Key: z.string().min(1),
  fileName: z.string().min(1).max(255),
  contentType: z.enum(ALLOWED_MIME_TYPES),
  sizeBytes: z.number().int().positive().max(MAX_FILE_SIZE_BYTES),
});

export const presignFileSchema = z.object({
  fileName: z.string().min(1).max(255),
  contentType: z.enum(ALLOWED_MIME_TYPES),
  sizeBytes: z.number().int().positive().max(MAX_FILE_SIZE_BYTES),
});

export const presignUploadRequestSchema = z.object({
  files: z
    .array(presignFileSchema)
    .min(1)
    .max(MAX_FILES_PER_SUBMISSION),
});
